<!-- [x]: rendere la sezione un component generico -->
<header-pre-head></header-pre-head>

<header class="gb_headerEnte">
  <div class="container">
    <div class="row">
      <div class="col-12 gb_innerEnteHead d-flex align-items-center justify-content-between">
        <div class="gb_EnteName">
          <ng-container *ngIf="storeService.authority">
            <ng-container *ngFor="let authorityLocale of storeService.authority.locales">
              <ng-container *ngIf="authorityLocale.active">
                <a href="javascript:void(0);" [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/auth']"
                  title="{{authorityLocale.descrizioneBreve}}" tabindex="0"
                  attr.aria-label="{{authorityLocale.descrizioneBreve}}">
                  <figure class="gb_brand m-0">
                    <img src="{{storeService.authority.urlLogoEnte}}" width="70" height="100" class="img-fluid" />
                  </figure>
                  <h1>{{ "generic.labels.portalTitle" | translate }}
                    <strong>{{ authorityLocale.descrizioneBreve }}</strong>
                  </h1>
                </a>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <nav>
          <!-- When a menu item, or direct child, is the current page add to anchor text .active class -->
          <div class="gb_bottomLink">
            <app-module-language></app-module-language>
            <ul>
              <li>
                <ng-container *ngIf="{ isLogged: (isLogged$ | async) } as vm">
                  <a id="gb_areaPmenu" (click)="toggleUserMenu()"
                    [routerLink]="!vm.isLogged ? [  '/'+this.storeService.authority?.codiceIpaEnte+'/auth' ] : null"
                    title="{{ !vm.isLogged ? ('generic.labels.login' | translate) : '' }}" tabindex="0" [ngClass]="{
                    'disabled': !(storeService.authority && storeService.authority.configurazioneAutenticazione && storeService.authority.configurazioneAutenticazione.isAuthenticationEnabled),
                    'active': vm.isLogged,
                    'cursor-pointer': true,
                    'opnsub': isUserMenuOpened
                  }">
                    <em class="gb-speak-none" aria-hidden="true">
                      <svg viewBox="0 0 24 24">
                        <path
                          d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" />
                      </svg>
                    </em>
                    <ng-container *ngIf="vm.isLogged === true; else loginTemplate">
                      {{ (personalData$ | async)?.given_name }}
                    </ng-container>
                    <ng-template #loginTemplate>
                      <span>{{ 'generic.labels.login' | translate }}</span>
                    </ng-template>
                  </a>
                </ng-container>

                <div id="gb_menuAreaPers" aria-labelledby="gb_areaPmenu" [attr.aria-hidden]="!isUserMenuOpened">
                  <a href="javascript:void(0);" class="gb-popupopener" data-popup-open="alert_multiutente" tabindex="0"
                    id="alert-multiutente" [attr.aria-label]="'multi-user-home'|translate"
                    [title]="'multi-user-home'|translate" aria-controls="homemultiutente" aria-haspopup="true"
                    role="popup">
                    {{ 'multi-user-home'|translate }}
                  </a>
                  <a href="javascript:void(0);"
                    [routerLink]="['/' + this.storeService.authority?.codiceIpaEnte + '/personal/mydata']"
                    [title]="'personal-data'|translate" [attr.aria-label]="'personal-data'|translate" tabindex="0">
                    {{ 'personal-data'|translate }}
                  </a>
                  <a (click)="logoutAndGoToHome()" href="javascript:void(0);" [title]="'exit'|translate"
                    [attr.aria-label]="'exit'|translate" tabindex="0">
                    {{ 'exit'|translate }}
                  </a>
                </div>
              </li>
              <li class="gb_cartV">
                <app-cart-icon-header></app-cart-icon-header>
              </li>
            </ul>

            <button type="button" title="Menu hamburger" aria-label="Menu hamburger" tabindex="0"
              class="gb_hambmenubtn gb-button-reset d-block d-lg-none" (click)="openGeneralMenu()">
              <span>
                <em></em>
                <em></em>
                <em></em>
                <span class="gb-hidden-visually gb-speak">Menu</span>
              </span>
            </button>
          </div>
          <div class="gb_topLink">
            <a routerLink="/{{authorityId}}/services-without-registration"
              title="{{'generic.labels.withoutRegistration' | translate}}"
              attr.aria-label="{{'generic.labels.withoutRegistration' | translate}}" tabindex="0">
              {{ "generic.labels.withoutRegistration" | translate }}
            </a>
          </div>
        </nav>
      </div>
    </div>
  </div>
</header>

<div id="gb_breadcrumb">
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <div class="gb_welcomeside">
          <ul class="gb_bcrumb">
            <!-- HOME -->
            <li>
              <a href="javascript:void(0);"
                *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''"
                (click)="askToLogout()" title="Homepage" tabindex="0" aria-label="Homepage">Home</a>
              <a href="javascript:void(0);"
                *ngIf="!storeService.authority || !storeService.authority.codiceIpaEnte || storeService.authority.codiceIpaEnte == ''"
                (click)="askToLogout()" title="Homepage" tabindex="0" aria-label="Homepage">Home</a>
            </li>
            <!-- ENTE -->
            <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
              <ng-container *ngIf="storeService.authority">
                <ng-container *ngFor="let authorityLocale of storeService.authority.locales">
                  <ng-container *ngIf="authorityLocale.active">
                    <a href="javascript:void(0);" [routerLink]="['/'+storeService.authority.codiceIpaEnte]" title="Ente"
                      tabindex="0" aria-label="Ente">
                      {{ authorityLocale.descrizioneBreve }}
                    </a>
                  </ng-container>
                </ng-container>
              </ng-container>
            </li>
            <ng-container *ngIf="pathname.includes('/personal/dashboard')">
              <li>{{ 'personal-area' | translate }}</li>
            </ng-container>

            <ng-container *ngIf="{ isLogged: isLogged$ | async } as vm2">
              <ng-container *ngIf="pathname.includes('/payment-return')">
                <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                  <a href="javascript:void(0);"
                    [routerLink]="['/'+storeService.authority.codiceIpaEnte+(vm2.isLogged?'/personal/dashboard':'/services-without-registration')]"
                    [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                    {{ 'personal-area'|translate }}
                  </a>
                </li>
                <li>{{ 'payment' | translate }}</li>
              </ng-container>
            </ng-container>

            <!-- mydata-->
            <ng-container *ngIf="pathname.includes('/personal/mydata')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                  {{ 'personal-area'|translate }}
                </a>
              </li>
              <li>{{ 'personal-data' | translate }}</li>
            </ng-container>
            <!-- privacy-->
            <ng-container *ngIf="pathname.includes('/personal/privacy')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                  {{ 'personal-area'|translate }}
                </a>
              </li>
              <li>{{ 'generic.buttons.privacy' | translate }}</li>
            </ng-container>
            <!-- legal-->
            <ng-container *ngIf="pathname.includes('/personal/legal')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                  {{ 'personal-area'|translate }}
                </a>
              </li>
              <li>{{ 'generic.buttons.legal' | translate }}</li>
            </ng-container>

            <ng-container *ngIf="pathname.includes('/personal/search-debt-position')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                  {{ 'personal-area'|translate }}
                </a>
              </li>
              <li>{{ 'search-position-with-advise-code'|translate }}</li>
            </ng-container>

            <ng-container *ngIf="pathname.includes('/personal/spontaneous-payment')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area' | translate" tabindex="0" [attr.aria-label]="'personal-area' | translate">
                  {{ 'personal-area' | translate }}
                </a>
              </li>
              <li
                *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''"
                [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/spontaneous-payment']" tabindex="0"
                [title]="'spontaneous-payment' | translate" [attr.aria-label]="'spontaneous-payment' | translate">
                {{ 'spontaneous-payment' | translate }}
              </li>
            </ng-container>

            <ng-container *ngIf="pathname.includes('/personal/payment-area/cart')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                  {{ 'personal-area'|translate }}
                </a>
              </li>
              <li>{{'payment-area-cart'|translate}}</li>
            </ng-container>

            <ng-container *ngIf="pathname.includes('/services-without-registration/mydata')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                  {{ 'personal-area'|translate }}
                </a>
              </li>
              <li>
                {{ 'personal-data' | translate }}
              </li>
            </ng-container>

            <ng-container *ngIf="router.url.includes('services-without-registration/spontaneous-payment')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/services-without-registration']"
                  tabindex="0" [title]="'no-registration-services'|translate"
                  [attr.aria-label]="'no-registration-services'|translate">
                  {{'no-registration-services'|translate}}
                </a>
              </li>
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''"
                [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/services-without-registration/spontaneous-payment']"
                tabindex="0" [title]="'spontaneous-payment' | translate"
                [attr.aria-label]="'spontaneous-payment' | translate">
                {{ 'spontaneous-payment' | translate }}
              </li>
            </ng-container>

            <ng-container *ngIf="router.url.includes('services-without-registration/payment-area/cart')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/services-without-registration']"
                  [title]="'no-registration-services'|translate"
                  [attr.aria-label]="'no-registration-services'|translate">
                  {{'no-registration-services'|translate}}
                </a>
              </li>
              <li>{{'payment-area-cart'|translate}}</li>
            </ng-container>

            <ng-container *ngIf="pathname.includes('/services-without-registration/mydata')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                  {{ 'personal-area'|translate }}
                </a>
              </li>
              <li>
                {{ 'personal-data' | translate }}
              </li>
            </ng-container>

            <!-- THEMATIC AREA Search -->
            <ng-container *ngIf="pathname.includes('/personal/thematic-area')">
              <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                <a href="javascript:void(0);"
                  [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/dashboard']"
                  [title]="'personal-area'|translate" tabindex="0" [attr.aria-label]="'personal-area'|translate">
                  {{ 'personal-area'|translate }}
                </a>
              </li>
              <ng-container *ngIf="!pathname.includes('/personal/thematic-area/category/') && !pathname.includes('/personal/thematic-area/service/')">
                <li>Pagamento Predeterminato</li>
              </ng-container>
              <!-- THEMATIC AREA Detail -->
              <ng-container *ngIf="pathname.includes('/personal/thematic-area/category/') || pathname.includes('/personal/thematic-area/service/')">
                <li *ngIf="storeService.authority && storeService.authority.codiceIpaEnte && storeService.authority.codiceIpaEnte != ''">
                  <a href="javascript:void(0);"
                    [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/personal/thematic-area']"
                    [title]="'Pagamento predeterminato'" tabindex="0" [attr.aria-label]="'Pagamento predeterminato'">
                    Pagamento Predeterminato
                  </a>
                </li>
                <li>Tributi</li>
              </ng-container>
            </ng-container>
          </ul>
          <span *ngIf="router.url.includes('/personal')">
            {{'welcome-to-your-personal-area-before'|translate }}
            <strong>
              {{ (personalData$ | async)?.given_name }}
            </strong>
            {{'welcome-to-your-personal-area-after'|translate }}
          </span>
        </div>
        <div class="gb_pepPAloghiSide">
          <img src="./assets/gb/img/logo-pap.svg" alt="Plug&Pay" width="451" height="293" aria-label="Plug" />
          <svg viewBox="0 0 72 48">
            <title>PagoPA</title>
            <path class="st0" d="M50.7,14.4l0,6.1h-4.4V0h4.4h0.5h3.2c2.6,0,3.9,0.7,4,2.1v10c0,1.4-1.3,2.1-3.8,2.1h-3.8L50.7,14.4L50.7,14.4z
 M54,2.4h-3.3v9.5H54V2.4z" />
            <path class="st0" d="M3.7,20.5l0,6.1H0V6.1h3.7h0.4h2.7c2.2,0,3.3,0.7,3.3,2.1v10c0,1.4-1.1,2.1-3.2,2.1H3.7V20.5z M6.5,8.5H3.7v9.5
h2.8V8.5z" />
            <path class="st0" d="M21.5,20.3h-7c-2.1,0-3.1-0.7-3.1-2.1l0-4.2c0-1.4,1.1-2.1,3.2-2.1h3.2V8.5h-2.8l0,1.9h-3.6V8.2
c0-1.4,1.1-2.1,3.2-2.1l3.6,0c2.1,0,3.2,0.7,3.2,2.1V20.3z M15.1,17.9h2.8l0-3.7h-2.8V17.9z" />
            <path class="st0" d="M29.6,20.3h-3.2c-2.1,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.3-2.1h2.7h0.5h3.7v18.3c0,1.4-1.1,2.1-3.2,2.1
h-3.7c-2.1,0-3.2-0.7-3.2-2.1v-2.1h3.7v1.9h2.8v-3.7L29.6,20.3z M26.8,17.9h2.8V8.5h-2.8V17.9z" />
            <path class="st0" d="M44.7,18.2c0,1.4-1.1,2.1-3.3,2.1h-3.6c-2.2,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.2-2.1h3.7
c2.1,0,3.2,0.7,3.2,2.1L44.7,18.2L44.7,18.2z M41,8.5h-2.8v9.5H41L41,8.5z" />
            <path class="st0" d="M72,2.2c0-1.4-1.3-2.1-3.8-2.1h-4.4c-2.6,0-3.9,0.7-3.9,2.1v18.3h4.4v-6.2h3.3v5.2c0,13.4-10.7,24.2-24,24.2
c-7.7,0-14.6-3.7-19-9.3l2.2-1.7l-8.8-6l0.4,12.6l2.8-2.3c5.2,6.7,13.3,11,22.4,11C59.3,48,72,35.2,72,19.4L72,2.2z M67.6,11.9h-3.3
V2.5h3.3V11.9z" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="dataAggiornamento$ | async as dataAggiornamento">
  <div id="gb_updatestatus" *ngIf="router.url.includes('/personal')">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center text-md-end">
          <p>
            <small>
              {{ 'updated-at'|translate }}
              <time>{{ dataAggiornamento | date:'dd/MM/yyyy HH:mm' }}</time>
              <a type="button" class="button-as-text small ms-2"
                [ngClass]="{'disabled': disableAggiornamentoButton$ | async}"
                [title]="'generic.buttons.lastUpdate'|translate"
                [attr.aria-label]="'generic.buttons.lastUpdate'|translate" tabindex="0" (click)="aggiorna()">
                {{'generic.buttons.lastUpdate'|translate}}
              </a>
            </small>
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div id="gb_mobimenu" class="gb_entemobimenu" aria-labelledby="gb_focusableMenu"
  [attr.aria-hidden]="!isGeneralMenuOpened" [ngClass]="{ 'opn': isGeneralMenuOpened }">
  <div class="gb_menucont">
    <div class="gb_headMenuMobiEnte">
      <div class="gb_EnteName">
        <ng-container *ngIf="storeService.authority">
          <ng-container *ngFor="let authorityLocale of storeService.authority.locales">
            <ng-container *ngIf="authorityLocale.active">
              <a href="javascript:void(0);" [routerLink]="['/'+storeService.authority.codiceIpaEnte+'/auth']"
                title="{{authorityLocale.descrizioneBreve}}" tabindex="0"
                attr.aria-label="{{authorityLocale.descrizioneBreve}}">
                <figure class="gb_brand m-0">
                  <img src="{{storeService.authority.urlLogoEnte}}" [alt]="authorityLocale.descrizioneBreve" width="70"
                    height="100" class="img-fluid">
                </figure>
                <h1>{{ "generic.labels.portalTitle" | translate }}
                  <strong>{{ authorityLocale.descrizioneBreve }}</strong>
                </h1>
              </a>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <button type="button" title="{{'section.header.labels.closeMenu' | translate}}"
        attr.aria-label="{{'section.header.labels.closeMenu' | translate}}" tabindex="0"
        class="gb_closemenubtn gb-button-reset" (click)="openGeneralMenu()">
        <span>
          <em></em>
          <em></em>
          <em></em>
          <em class="gb-hidden-visually gb-speak">{{ "section.header.labels.closeMenu" | translate }}</em>
        </span>
      </button>
    </div>

    <menu>
      <ul>
        <li *ngIf="(isLogged$ | async) === false">
          <a href="javascript:void(0);" [routerLink]="['/'+authorityId+'/personal/dashboard']"
            (click)="openGeneralMenu()" class="gb_btncta w colt"
            [title]="'generic.buttons.accessToPersonalArea' | translate"
            [attr.aria-label]="'generic.buttons.accessToPersonalArea' | translate"
            [ngClass]="{'disabled': !(storeService.authority && storeService.authority.configurazioneAutenticazione && storeService.authority.configurazioneAutenticazione.isAuthenticationEnabled)}">
            {{ 'generic.buttons.accessToPersonalArea' | translate }}
          </a>
        </li>
        <li *ngIf="(isLogged$ | async) === true">
          <a routerLink="/{{authorityId}}/services-without-registration" (click)="openGeneralMenu()"
            title="{{'generic.labels.withoutRegistration' | translate}}" tabindex="0">
            {{ "generic.labels.withoutRegistration" | translate }}
          </a>
        </li>

        <li>
          <a href="javascript:void(0);" class="gb-popupopener" data-popup-open="alert_multiutente" tabindex="0"
            [attr.aria-label]="'multi-user-home'|translate" [title]="'multi-user-home'|translate"
            aria-controls="homemultiutente" aria-haspopup="true" (click)="openGeneralMenu()" role="popup">
            {{ 'multi-user-home'|translate }}
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" (click)="openGeneralMenu()"
            [routerLink]="['/' + this.storeService.authority?.codiceIpaEnte + '/personal/mydata']"
            [title]="'personal-data'|translate" [attr.aria-label]="'personal-data'|translate" tabindex="0">
            {{ 'personal-data'|translate }}
          </a>
        </li>
        <li>
          <a (click)="openGeneralMenu(); logoutAndGoToHome()" href="javascript:void(0);" [title]="'exit'|translate"
            [attr.aria-label]="'exit'|translate" tabindex="0">
            {{ 'exit'|translate }}
          </a>
        </li>
      </ul>
    </menu>

    <app-module-language-mobile></app-module-language-mobile>

    <div class="gb_pepPAloghiSide">
      <img src="./assets/gb/img/logo-pap.svg" alt="Plug&Pay" width="451" height="293" aria-label="Plug" />
      <svg viewBox="0 0 72 48">
        <title>PagoPA</title>
        <path class="st0" d="M50.7,14.4l0,6.1h-4.4V0h4.4h0.5h3.2c2.6,0,3.9,0.7,4,2.1v10c0,1.4-1.3,2.1-3.8,2.1h-3.8L50.7,14.4L50.7,14.4z
 M54,2.4h-3.3v9.5H54V2.4z" />
        <path class="st0" d="M3.7,20.5l0,6.1H0V6.1h3.7h0.4h2.7c2.2,0,3.3,0.7,3.3,2.1v10c0,1.4-1.1,2.1-3.2,2.1H3.7V20.5z M6.5,8.5H3.7v9.5
h2.8V8.5z" />
        <path class="st0" d="M21.5,20.3h-7c-2.1,0-3.1-0.7-3.1-2.1l0-4.2c0-1.4,1.1-2.1,3.2-2.1h3.2V8.5h-2.8l0,1.9h-3.6V8.2
c0-1.4,1.1-2.1,3.2-2.1l3.6,0c2.1,0,3.2,0.7,3.2,2.1V20.3z M15.1,17.9h2.8l0-3.7h-2.8V17.9z" />
        <path class="st0" d="M29.6,20.3h-3.2c-2.1,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.3-2.1h2.7h0.5h3.7v18.3c0,1.4-1.1,2.1-3.2,2.1
h-3.7c-2.1,0-3.2-0.7-3.2-2.1v-2.1h3.7v1.9h2.8v-3.7L29.6,20.3z M26.8,17.9h2.8V8.5h-2.8V17.9z" />
        <path class="st0" d="M44.7,18.2c0,1.4-1.1,2.1-3.3,2.1h-3.6c-2.2,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.2-2.1h3.7
c2.1,0,3.2,0.7,3.2,2.1L44.7,18.2L44.7,18.2z M41,8.5h-2.8v9.5H41L41,8.5z" />
        <path class="st0" d="M72,2.2c0-1.4-1.3-2.1-3.8-2.1h-4.4c-2.6,0-3.9,0.7-3.9,2.1v18.3h4.4v-6.2h3.3v5.2c0,13.4-10.7,24.2-24,24.2
c-7.7,0-14.6-3.7-19-9.3l2.2-1.7l-8.8-6l0.4,12.6l2.8-2.3c5.2,6.7,13.3,11,22.4,11C59.3,48,72,35.2,72,19.4L72,2.2z M67.6,11.9h-3.3
V2.5h3.3V11.9z" />
      </svg>
    </div>
  </div>
</div>
